const page = "SearchPage";

export default page;
